import React from 'react';
import ModuleGuidance from './ModuleGuidance';
import { AdBanner, SLOT_MODULE_TOP } from './ads/Ads';

// REVAMP: the "How to use" box and the top ad banner, rendered inside each
// module directly below its own banner (module-header) instead of above it.
const ModuleTopExtras: React.FC<{ moduleId: string }> = ({ moduleId }) => (
  <>
    <ModuleGuidance moduleId={moduleId} />
    <AdBanner label="module-top" slot={SLOT_MODULE_TOP} leaderboard style={{ margin: '0 auto 16px' }} />
  </>
);

export default ModuleTopExtras;
